import { emptyAction, payloadAction } from "../action/creators"
import { FlashData } from "./FlashData"

export const CLEAR_FLASH = "FLASH/CLEAR"
export const clearFlash = emptyAction(CLEAR_FLASH)

export const SET_FLASH = "FLASH/SET"
export const setFlash = payloadAction<FlashData>(SET_FLASH)
